import { Flex, useMediaQuery } from "@chakra-ui/react";
import { EmptyState } from "@pufflig/prompt-studio-ui";
import { useAuth } from "@/services/supabase/auth/AuthContext/useAuth";

export const MobileUnsupportedOverlay = () => {
  const { isAuthenticated } = useAuth();
  const [isMobile] = useMediaQuery("(max-width: 767px)");

  if (!isAuthenticated || !isMobile) {
    return null;
  }

  return (
    <Flex
      position="fixed"
      top="4rem"
      left={0}
      right={0}
      bottom={0}
      zIndex={1}
      alignItems="center"
      justifyContent="center"
      bg="background.primary"
      padding="spacing-md"
    >
      <EmptyState
        title="Mobile not supported"
        description="We currently do not support mobile screens."
        showBackground
        size="md"
      />
    </Flex>
  );
};
